function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "#F2F5F9"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.5 20.5h-44v16h44v-16zM62.5 44.5h-44v16h44v-16zM28.5 28.5h-4M28.5 52.5h-4M38.5 28.5h-4M38.5 52.5h-4",
  stroke: "#4038FF",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.5 30.5a2 2 0 100-4 2 2 0 000 4zM54.5 54.5a2 2 0 100-4 2 2 0 000 4z",
  fill: "#4038FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24 37v7M56 37v7",
  stroke: "#4038FF",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var SvgRoleTechieActive = function SvgRoleTechieActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAiIGZpbGw9IiNGMkY1RjkiLz4KPHBhdGggZD0iTTYyLjUgMjAuNUgxOC41VjM2LjVINjIuNVYyMC41WiIgc3Ryb2tlPSIjNDAzOEZGIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTYyLjUgNDQuNUgxOC41VjYwLjVINjIuNVY0NC41WiIgc3Ryb2tlPSIjNDAzOEZGIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTI4LjUgMjguNUgyNC41IiBzdHJva2U9IiM0MDM4RkYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMjguNSA1Mi41SDI0LjUiIHN0cm9rZT0iIzQwMzhGRiIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0zOC41IDI4LjVIMzQuNSIgc3Ryb2tlPSIjNDAzOEZGIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTM4LjUgNTIuNUgzNC41IiBzdHJva2U9IiM0MDM4RkYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNNTQuNSAzMC41QzU1LjYwNDYgMzAuNSA1Ni41IDI5LjYwNDYgNTYuNSAyOC41QzU2LjUgMjcuMzk1NCA1NS42MDQ2IDI2LjUgNTQuNSAyNi41QzUzLjM5NTQgMjYuNSA1Mi41IDI3LjM5NTQgNTIuNSAyOC41QzUyLjUgMjkuNjA0NiA1My4zOTU0IDMwLjUgNTQuNSAzMC41WiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBkPSJNNTQuNSA1NC41QzU1LjYwNDYgNTQuNSA1Ni41IDUzLjYwNDYgNTYuNSA1Mi41QzU2LjUgNTEuMzk1NCA1NS42MDQ2IDUwLjUgNTQuNSA1MC41QzUzLjM5NTQgNTAuNSA1Mi41IDUxLjM5NTQgNTIuNSA1Mi41QzUyLjUgNTMuNjA0NiA1My4zOTU0IDU0LjUgNTQuNSA1NC41WiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBkPSJNMjQgMzdWNDQiIHN0cm9rZT0iIzQwMzhGRiIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik01NiAzN1Y0NCIgc3Ryb2tlPSIjNDAzOEZGIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPC9zdmc+Cg==";
export { SvgRoleTechieActive as ReactComponent };